import { render, staticRenderFns } from "./stat-cell.vue?vue&type=template&id=5857a1b2&scoped=true"
import script from "./stat-cell.vue?vue&type=script&lang=ts"
export * from "./stat-cell.vue?vue&type=script&lang=ts"
import style0 from "./stat-cell.vue?vue&type=style&index=0&id=5857a1b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5857a1b2",
  null
  
)

export default component.exports